module.exports = __webpack_public_path__ + "static/media/pos-main.58dd7930.svg";